export { CareersPage as default } from '@/components/pages/Careers'
